"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var CheckBoxWidget_1 = require("./CheckBoxWidget");
var DomWidgets_1 = require("./DomWidgets");
var ClickBusting_1 = require("../config/ClickBusting");
var DynamicThemeComponent_1 = require("./DynamicThemeComponent");
var InteractiveDom_1 = require("../utils/InteractiveDom");
var InputLabelWidget_1 = require("./InputLabelWidget");
var TabStyles_1 = require("../styles/TabStyles");
var getStyles = function () {
    return {
        label: {
            display: 'flex',
            minHeight: TabStyles_1.TabStyles.Sizing.ListRowHeight,
        },
        text: {
            overflow: 'hidden',
            paddingTop: '1px',
            textOverflow: 'ellipsis',
            width: '100%',
        },
    };
};
var CheckBoxWithLabelWidget = /** @class */ (function (_super) {
    tslib_1.__extends(CheckBoxWithLabelWidget, _super);
    function CheckBoxWithLabelWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckBoxWithLabelWidget.prototype.render = function () {
        var styles = getStyles();
        return (React.createElement(DomWidgets_1.Block, { className: ClickBusting_1.ClickBustingConfig.suppressionClassName, style: this.props.containerStyle },
            React.createElement(InputLabelWidget_1.InputLabelWidget, { disabled: this.props.disabled, style: styles.label, testId: this.props.testId },
                React.createElement(CheckBoxWidget_1.CheckBoxWidget, tslib_1.__assign({}, this.props, { hover: this.state.hover })),
                React.createElement(DomWidgets_1.InlineBlock, { "aria-label": this.props.label, style: styles.text }, this.props.label))));
    };
    CheckBoxWithLabelWidget = tslib_1.__decorate([
        InteractiveDom_1.InteractiveDomHoCDecorator
    ], CheckBoxWithLabelWidget);
    return CheckBoxWithLabelWidget;
}(DynamicThemeComponent_1.DynamicThemeComponent));
exports.CheckBoxWithLabelWidget = CheckBoxWithLabelWidget;
//# sourceMappingURL=CheckBoxWithLabelWidget.js.map